const style = {
  aria: {
    label: 'more',
    controls: 'long-button',
    id: 'long-menu',
  },
  menuItem: {
    sx: {
      svg: {
        color: '#6B7280',
        marginLeft: '18px',
      },
    },
  },
  reasonMenuItem: {
    sx: {
      '&:hover': {
        color: 'white',
        backgroundColor: '#EC0982 !important',
      },
    },
  },
  menuTitle: {
    fontSize: '12px',
    padding: '16px',
    color: '#b9b7c3',
  },
} as const;

export default style;
